import React, { JSX } from 'react';
import { BookedItemComponentProps } from '../../../Models/ItemRegistry';
import SummaryItem from '../../Components/Cart/SummaryItem/SummaryItem';

const Summary = (props: BookedItemComponentProps): JSX.Element => {
  const { item, customLabelsMapper, order } = props;

  const customLabel = customLabelsMapper && customLabelsMapper(item);
  return (
    <SummaryItem title={customLabel || item.name} item={item} order={order?.Bus}></SummaryItem>
  );
};

export default Summary;
